// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconUser = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M51.8517 56H12.1483C10.5998 56 9.80932 55.0688 10.0392 53.4581C11.9828 39.8437 13.3468 36.2941 24.5702 33.5331C21.6579 31.158 20 27.173 20 22C20 13.3615 24.5955 8 32 8C39.4045 8 44 13.3615 44 22C44 27.173 42.342 31.158 39.4298 33.5331C50.6532 36.2941 52.0171 39.8436 53.9607 53.4581C54.1907 55.0688 53.4001 56 51.8517 56Z" />
    </svg>
  );
};
